<template>
    <div class="face-rate">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <profileIcon :settings="profileIconSettings"></profileIcon>
        <gpsPopup :settings="gpsPopupSettings"></gpsPopup>
        <allowGpsRequestPopup :settings="allowGpsRequestPopupSettings"></allowGpsRequestPopup>
        <confirmCroJobPopup :settings="confirmCroJobPopupSettings"></confirmCroJobPopup>
        <gpsErrorPopup :settings="gpsErrorPopupSettings"></gpsErrorPopup>
        <w3wPopup :settings="w3wPopupSettings"></w3wPopup>
        <div class="place">
            <div class="place_img">
                <img v-if="placeImg != null" :src="placeImg" alt="place img">
                <img v-else alt="place img" src="../assets/re/default_place_img.jpg">
            </div>
        </div>
        <div class="question">{{ place_info.question }}</div>
        <div class="question__id">{{ translate('manageScreenQuestion') }} #{{ questionInfo.id }}</div>
        <div class="question-map__form">
            <div class="input-wrapper"
                 v-if="assetIdConfig && assetIdConfig.show">
                <input class="sign-input" required type="text" v-model="assetId"
                       :placeholder="assetIdConfig.placeholder ? assetIdConfig.placeholder : ''">
                <label class="form-lable">{{ assetIdConfig.label ? assetIdConfig.label : translate('manageSetAsset')}}</label>
                <div class="field_action_btn" :class="{disabled: this.assetId == this.questionInfo.asset_id}" @click="onAssetIdSaveClick"><span>{{ translate('Save') }}</span></div>
            </div>
            <div class="input-wrapper"
                 v-if="placementConfig && placementConfig.show">
                <input class="sign-input" required type="text" v-model="placement"
                       :placeholder="placementConfig.placeholder ? placementConfig.placeholder : ''"
                       :disabled="disablePlacementFieldsTmp">
                <label class="form-lable">{{ placementConfig.label ? placementConfig.label : translate('manageScreenLocation')}}</label>
                <div class="field_action_btn" :class="{disabled: this.placement == this.questionInfo.placement}" @click="onPlacementSaveClick"><span>{{ translate('Save') }}</span></div>
            </div>
            <div class="input-wrapper"
                 v-if="croJobIdConfig && croJobIdConfig.show">
                <input class="sign-input" required type="number" v-model="croJobId" :placeholder="croJobIdConfig.placeholder ? croJobIdConfig.placeholder : 'Enter CRO Job ID'"
                :disabled="disablePlacementFieldsTmp">
                <label class="form-lable">{{ croJobIdConfig.label ? croJobIdConfig.label : "Change asset location"}}</label>
                <div class="field_action_btn" :class="{disabled: croJobId == '' || disablePlacementFieldsTmp}" @click="onCROJobApplyClick"><span>Apply</span></div>
            </div>
            <div class="input-wrapper"
                 v-if="croAssetNumberConfig && croAssetNumberConfig.show">
                <input class="sign-input" required type="text" v-model="croAssetNumber" :placeholder="croAssetNumberConfig.placeholder ? croAssetNumberConfig.placeholder : 'Enter CRO Asset Number'" @input="onAssetNumberChanged" @focusin="onAssetNumberFocused" @focusout="onAssetNumberUnFocused">
                <label class="form-lable">{{ croAssetNumberConfig.label ? croAssetNumberConfig.label : "For DUMPSTERS:"}}</label>
                <div class="field_action_btn" :class="{disabled: croAssetNumber == '' || croAssetNumber == questionInfo.cro_asset_number}" @click="onCROAssetNumberApplyClick"><span>Apply</span></div>
                <div class="assets_autocomplete_list" v-if="croAssetAutoSuggestCollection.length != 0">
                    <div class="item" v-for="item in croAssetAutoSuggestCollection" @click="onAssetNumberItemClick(item)">{{ item.number }}</div>
                </div>
            </div>
            <div class="input-wrapper asset_type_selector"
                 v-if="croAssetTypeConfig && croAssetTypeConfig.show">
                <b-dropdown
                    :text="croAssetTypeName != '' ? croAssetTypeName : (croAssetTypeConfig.placeholder ? croAssetTypeConfig.placeholder : 'Choose type')"
                    no-caret>
                    <b-dropdown-item v-for="item in croAssetTypeAutoSuggestCollection"
                                     v-on:click="onAssetTypeItemClick(item)"
                                     :key="item.id">
                        <span>{{ item.name }}</span>
                    </b-dropdown-item>
                </b-dropdown>
                <label class="form-lable">{{ croAssetTypeConfig.label ? croAssetTypeConfig.label : "Choose asset type:"}}</label>
            </div>
            <div v-if="!hasLocation && (geolocationConfig && geolocationConfig.show)" class="map-image">
                <div class="map-image__overlay" @click="onSetGeolocationClick">
                    <img src="../assets/images/map_screenshot.png">
                    <div class="overlay-content">{{ translate('manageSetGeolocation') }}</div>
                </div>
                <div v-if="showMapLoader" class="map-block__loader default">
                    <md-progress-spinner id="progressbar" :md-diameter="60"
                                         md-mode="indeterminate" class="mapProgress"></md-progress-spinner>
                    <span>Detecting geolocation</span>
                </div>
            </div>
            <div v-else-if="geolocationConfig && geolocationConfig.show" class="map-block">
                <div class="map-block__wrapper">
                    <div class="block-title">{{ translate('manageGeolocation') }}</div>
                </div>
                <div class="map-block__content">
                    <div class="modal-map">
                        <div class="map-picture" @click="onMapBlockClick">
                            <img
                                :src="`${baseUrl}/google-map-preview?lat=${this.locationData.lat}&lng=${this.locationData.lng}`">
                            <div class="map-point">
                                <img src="@/assets/icons/map-point.png">
                            </div>
                            <div v-if="showMapLoader" class="map-block__loader">
                                <md-progress-spinner :md-diameter="60"
                                                     md-mode="indeterminate" class="mapProgress"></md-progress-spinner>
                                <span>Detecting geolocation</span>
                            </div>
                            <div class="map-block__accuracy"
                                 v-if="this.locationData.source == 'gps' && this.locationData.accuracy !== 0">
                                {{ translate('manageGPSAccuracy', [Math.round(this.locationData.accuracy)]) }}
                            </div>
                        </div>
                    </div>
                    <div class="map-block__btn">
                        <div class="update-btn" @click="onUpdateGeolocationClick">
                            <div class="update-btn__icon">
                                <img src="@/assets/icons/update-cords__icon.svg">
                            </div>
                            <div class="update-btn__text">
                                {{ translate('manageUpdateBtn') }}
                            </div>
                        </div>
                        <div class="cords-btn" @click="moreInfoButtonClick">
                            <div class="cords-btn__icon">
                                <img src="@/assets/icons/change-cords__icon.svg">
                            </div>
                            <div class="cords-btn__arrow" v-if="showManualCordsForm">
                                <img src="@/assets/icons/icon_grey-up.svg">
                            </div>
                            <div class="cords-btn__arrow" v-else>
                                <img src="@/assets/icons/icon_grey-down.svg">
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="showManualCordsForm" class="cords-form">
                    <div class="cords-input__number">
                        <div class="input-cords__wrapper">
                            <input v-model="this.locationData.latCropped" class="sign-input click-input" readonly
                                   type="text" @click="onLatClick">
                            <label class="cords-form__label-lat">{{ translate('manageLatitude') }}</label>
                            <input v-model="this.locationData.lat" id="latInput" type="hidden">
                        </div>
                        <div class="input-cords__wrapper-second">
                            <input v-model="this.locationData.lngCropped" class="sign-input click-input" readonly
                                   type="text" @click="onLngClick">
                            <label class="cords-form__label-lng">{{ translate('manageLongitude') }}</label>
                            <input v-model="this.locationData.lng" id="lngInput" type="hidden">
                        </div>
                    </div>
                    <div class="cords-input__w3w">
                        <div class="input-wrapper">
                            <input class="sign-input click-input" v-model="w3w" readonly type="text" id="w3wInput"
                                   @click="onW3WInputClick">
                            <label class="form-lable">What3Words</label>
                        </div>
                        <div class="w3w-icon" @click="showW3Wpopup">
                            <img src="@/assets/icons/w3w_info.svg">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="back_to_yard-btn-wrapper">
            <b-button class="back_to_yard-btn" @click="onBackToYardClick" v-if="clearPlacementInfoConfig && clearPlacementInfoConfig.show">
                {{ clearPlacementInfoConfig.label ? clearPlacementInfoConfig.label : translate('manage_back_to_yard') }}
            </b-button>
        </div>
    </div>
</template>

<script>
import rateMixin from '@/mixins/rateMixin';
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import profileIcon from "./voteFlow/widgets/profileIcon.vue";
import gpsPopup from "./widgets/gpsPopup";
import allowGpsRequestPopup from "./widgets/allowGpsRequestPopup";
import customModalDialog from '@/components/widgets/customModalDialog';
import gpsErrorPopup from "./widgets/gpsErrorPopup";
import w3wPopup from "./widgets/w3wPopup";
import errorMixin from '@/mixins/errorMixin';
import mapMixin from "@/mixins/mapMixin";
import geoLocationMixin from "@/mixins/geoLocationMixin";
import config from '@/api/config';
import logAnalyticsEvent from "@/helpers/analytics";
import confirmCroJobPopup from "./widgets/confirmCroJobPopup";

export default {
    mixins: [mixin, rateMixin, errorMixin, config, geoLocationMixin, mapMixin],
    name: "question_manage_screen",
    components: {
        confirmCroJobPopup,
        profileIcon,
        gpsPopup,
        allowGpsRequestPopup,
        gpsErrorPopup,
        w3wPopup,
        customModalDialog,
    },
    data() {
        return {
            showMapLoader: false,
            place_info: {
                place: {
                    name: '',
                },
                question: '',
            },
            question_id: this.$route.params.questionId,
            gpsPopupSettings: {
                show: false
            },
            placeWithoutCords: false,
            showManualCordsForm: false,
            allowGpsRequestPopupSettings: {
                show: false
            },
            gpsErrorPopupSettings: {
                show: false
            },
            w3wPopupSettings: {
                show: false
            },
            confirmCroJobPopupSettings: {
                show: false,
            },
            hasLocation: false,
            mapOptions: {
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUi: false,
                gestureHandling: 'greedy',
                mapTypeId: 'roadmap'
            },
            zoom: 18,
            mapApiKey: config.STATIC_MAP_API_KEY,
            baseUrl: config.baseUrl,
            profileIconSettings: {
                longTapForLogout: true
            },
            customModalSettings: {},
            croJobId: "",
            croAssetNumber: "",
            croAssetTypeName: "",
            croAssetAutoSuggestCollection: [],
            croAssetAutoSuggestLoadIndex: 0,
            croAssetTypeAutoSuggestCollection: [],
            disablePlacementFieldsTmp: false,
        }
    },
    watch: {
        isAuthorized(newValue) {
            if (!newValue) {
                this.$store.commit('rate/clearGiveaway')
            }
        },
        locationData(newValue) {
            this.hasLocation = newValue.lat !== 0 && newValue.lng !== 0
        },
    },
    computed: {
        ...mapState({
            accessToken: state => state.auth.accessToken,
        }),
        ...mapGetters({
            isAuthorized: 'auth/isAuthorized',
            questionInfo: 'questionManage/getQuestionInfo',
            getLocationData: 'questionManage/getLocationData',
            newQuestionInfo: 'questionManage/getNewQuestionInfo',
            isUserAdmin: 'auth/isUserAdmin',
        }),

        placeImg() {
            let i = this.questionInfo
            return i && i.place && i.place.preview.length != 0 ? i.place.preview : null
        },

        croJobIdConfig() {
            return this.questionInfo.q_manage_screen_config ? this.questionInfo.q_manage_screen_config.cro_job_id : null
        },

        croAssetNumberConfig() {
            return this.questionInfo.q_manage_screen_config ? this.questionInfo.q_manage_screen_config.cro_asset_number : null
        },

        croAssetTypeConfig() {
            return this.questionInfo.q_manage_screen_config ? this.questionInfo.q_manage_screen_config.cro_asset_type : null
        },

        assetIdConfig() {
            return this.questionInfo.q_manage_screen_config ? this.questionInfo.q_manage_screen_config.asset_id : null
        },

        placementConfig() {
            return this.questionInfo.q_manage_screen_config ? this.questionInfo.q_manage_screen_config.placement : null
        },

        geolocationConfig() {
            return this.questionInfo.q_manage_screen_config ? this.questionInfo.q_manage_screen_config.geolocation : null
        },

        clearPlacementInfoConfig() {
            return this.questionInfo.q_manage_screen_config ? this.questionInfo.q_manage_screen_config.clear_placement_info : null
        },

        locationData: {
            get() {
                return this.$store.state.questionManage.locationData
            },
            set(value) {
                this.$store.commit('questionManage/setLocationData', value)
            }
        },
        w3w: {
            get() {
                return this.$store.state.questionManage.locationData.w3w
            },
            set(value) {
                this.$store.commit('questionManage/setW3W', value)
            }
        },

        assetId: {
            get() {
                return this.$store.state.questionManage.newQuestionInfo.asset_id
            },
            set(value) {
                this.$store.commit('questionManage/setAssetId', value)
            }
        },
        placement: {
            get() {
                return this.$store.state.questionManage.newQuestionInfo.placement
            },
            set(value) {
                this.$store.commit('questionManage/setPlacement', value)
            }
        },

        hasChanges() {
            let initialLoc = this.questionInfo.location
            let hasInitialLoc = initialLoc != null
            let locData = this.getLocationData
            return (!hasInitialLoc && (locData.lat !== 0 || locData.lng !== 0 ))
                || (hasInitialLoc && !this.checkCoordsEqual(locData.lat, initialLoc.point.lat))
                || (hasInitialLoc && !this.checkCoordsEqual(locData.lng, initialLoc.point.lng))
                || this.placement !== this.questionInfo.placement
                || this.assetId !== this.questionInfo.asset_id
        },
    },
    async mounted() {
        this.showManualCordsForm = localStorage.getItem('qmng_geoinfo_opened') == 'true'
        if (this.questionInfo.id == null) {
            await this.getQuestionPlaceInfo()
            if(this.questionInfo.place == null) {
                if(this.isUserAdmin) {
                    localStorage.setItem('unlinked_rate', this.questionInfo.uid);
                    localStorage.setItem('unlinked_rate_question', this.questionInfo.question);
                    if (this.place_info.location) {
                        localStorage.setItem('unlinked_rate_question_location', this.questionInfo.placement);
                    }
                    localStorage.setItem('makeOwnerBool', true);
                    let url = window.location.origin + '/own-business'
                    window.open(url, "_self")
                    return
                } else {
                    //todo show some error???
                }
                return
            }
            this.resetToInitialData()//todo hack remove
            let w3w = await this.updateW3W() //todo hack remove
            this.$store.commit('questionManage/setQuestionInfoW3W', w3w) //todo hack remove
            this.resetToInitialData()
            if(this.questionInfo.cro_asset_number) {
                this.croAssetNumber = this.questionInfo.cro_asset_number
            }
            if(this.questionInfo.cro_asset_type) {
                this.croAssetTypeName = this.questionInfo.cro_asset_type.name
            }
            if(this.questionInfo.asset_types) {
                this.croAssetTypeAutoSuggestCollection = this.questionInfo.asset_types
            }
        }
        this.hasLocation = this.locationData.lat !== 0 && this.locationData.lng !== 0
    },
    methods: {
        ...mapActions({
            fetchQuestionInfo: 'questionManage/fetchQuestionInfo',
            saveQuestionInfo: 'questionManage/saveQuestionInfo',
            saveQuestionGPS: 'questionManage/saveQuestionGPS',
            changeQuestionPlacement: 'questionManage/changeQuestionPlacement',
            changeQuestionAssetId: 'questionManage/changeQuestionAssetId',
            logoutRemote: 'auth/logout',
            searchJobById: 'questionManage/searchJobById',
            setCROAssetNumberForQuestion: 'questionManage/setCROAssetNumberForQuestion',
            setCROAssetTypeForQuestion: 'questionManage/setCROAssetTypeForQuestion',
            setJobIdForQuestion: 'questionManage/setJobIdForQuestion',
            searchAssetByNumber: 'questionManage/searchAssetByNumber',
            clearPlacementInfo: 'questionManage/clearPlacementInfo',
        }),
        ...mapMutations({
            removeKeys: 'auth/removeKeys',
            setProgressBarTag: 'setProgressBarTag',
            setMessageModel: 'setMessageModel'
        }),
        async getQuestionPlaceInfo(hidden = false) {
            try {
                const response = await this.fetchQuestionInfo(this.question_id)
                console.log(response)
            } catch (e) {
                console.log(`error getQuestionPlaceInfo:`, e)
                if(e && e.data.error.code == 1013) {
                    logAnalyticsEvent('qm_no_perm')
                    this.customModalSettings = {
                        icon: 'close-circle-outline.svg',
                        message: this.translate('manageNotEnoughPermissions'),
                        onOkHandler: this.onNotEnoughPermissionLogoutClick,
                        onCancelHandler: this.onNotEnoughPermissionOkClick,
                        showCancelButton: true,
                        okButtonText: this.translate('Logout'),
                        cancelButtonText: this.translate('cancel'),
                    }
                } else if(e && e.data.error) {
                    this.showErrorModal(e.data.error.message)
                } else  {
                    logAnalyticsEvent('qm_no_unknown_error')
                    this.logout()
                }
            }
        },
        async updateW3W() {
            if(this.locationData.lat == 0 && this.locationData.lng == 0) return ''
            let words = await this.fetchW3WData(this.locationData.lat, this.locationData.lng)
            this.w3w = words
            return words
        },
        async onUpdateGeolocationClick() {
            await this.initFetchLocationFlow()
        },
        showGpsPopupClick() {
            this.gpsPopupSettings = {
                show: true
            }
        },

        async onPlacementSaveClick() {
            if(this.placement == this.questionInfo.placement) return
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'update placement'
                })
                const response = await this.changeQuestionPlacement({
                    body: {
                        placement: this.placement,
                    },
                    questionUid: this.question_id,
                })
                console.log(response.result)
                this.setMessageModel({
                    msg: 'Done',
                    duration: 2000
                })
                this.questionInfo.placement = this.placement
            } catch (e) {
                this.showErrorModal(e.data.error.message)
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'update placement'
                })
            }
        },

        async onAssetIdSaveClick() {
            if(this.assetId == this.questionInfo.asset_id) return
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'update asset_id'
                })
                const response = await this.changeQuestionAssetId({
                    body: {
                        asset_id: this.assetId,
                    },
                    questionUid: this.question_id,
                })
                console.log(response.result)
                this.setMessageModel({
                    msg: 'Done',
                    duration: 2000
                })
                this.questionInfo.asset_id = this.assetId
            } catch (e) {
                this.showErrorModal(e.data.error.message)
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'update asset_id'
                })
            }
        },

        async onCROJobApplyClick() {
            if(this.croJobId == '') return
            if(this.croJobIdConfig && this.croJobIdConfig.auto_gps) {
                this.initFetchLocationFlow(true)
            }
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'search cro job'
                })
                const response = await this.searchJobById({questionId: this.question_id, croJobId: this.croJobId})
                console.log(response.result)
                this.confirmCroJobPopupSettings = {
                    show: true,
                    jobData: response.result,
                    updatePlacement: true,
                    dateInstallSensitive: true,
                    onOkHandler: (updatePlacement, assetIsPortable) => {
                        this.confirmCroJobOkHandler(updatePlacement, assetIsPortable)
                    },
                }
            } catch (e) {
                console.log(`error onCROJobApplyClick:`, e)
                this.setMessageModel({
                    msg: `CRO JOB \"${this.croJobId}\" was not found. Please, enter a correct Job ID and try again.`,
                    duration: 3000
                })
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'search cro job'
                })
            }
        },

        async confirmCroJobOkHandler(updatePlacement, assetIsPortable) {
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'update cro question job'
                })
                const response = await this.setJobIdForQuestion({
                    questionId: this.question_id,
                    croJobId: this.croJobId,
                    updatePlacement: updatePlacement,
                    assetIsPortable: assetIsPortable,
                })
                console.log(response.result)
                if(updatePlacement) {
                    this.questionInfo.placement = response.result.new_placement
                    this.placement = response.result.new_placement
                }
                this.croJobId = ''
                this.setMessageModel({
                    msg: 'Saved',
                    duration: 3000
                })
            } catch (e) {
                console.log(`error setJobIdForQuestion:`, e)
                this.setMessageModel({
                    msg: 'Something went wrong. Please, try again.',
                    duration: 1000
                })
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'update cro question job'
                })
            }
        },

        onAssetNumberFocused() {
          console.log('onAssetNumberFocused')
        },
        onAssetNumberUnFocused() {
          console.log('onAssetNumberUnFocused')
            setTimeout(() => {
                this.croAssetAutoSuggestCollection = []
            }, 10);
        },
        onAssetNumberChanged() {
            console.log(this.croAssetNumber)
            if(this.croAssetNumber == '') {
                this.croAssetAutoSuggestLoadIndex++
                this.croAssetAutoSuggestCollection = []
                return
            }
            this.loadAssetsSuggestions()
        },
        async loadAssetsSuggestions() {
            this.croAssetAutoSuggestLoadIndex++
            let index = this.croAssetAutoSuggestLoadIndex
            try {
                const response = await this.searchAssetByNumber({
                    questionId: this.question_id,
                    assetNumber: this.croAssetNumber,
                })
                console.log(response.items)
                if(index != this.croAssetAutoSuggestLoadIndex) {
                    return
                }
                this.croAssetAutoSuggestCollection = response.items
            } catch (e) {
                console.log(`error setJobIdForQuestion:`, e)
                // this.setMessageModel({
                //     msg: 'Something went wrong. Please, try again.',
                //     duration: 1000
                // })
            } finally {

            }
        },

        onAssetNumberItemClick(item) {
            console.log('item click')
            this.croAssetNumber = item.number
            this.applyAssetNumber()
        },

        async onCROAssetNumberApplyClick() {
            this.applyAssetNumber()
        },

        async applyAssetNumber() {
            if(this.croAssetNumber == '' || this.croAssetNumber == this.questionInfo.cro_asset_number) return
            let assetNumber = this.croAssetNumber
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'apply asset'
                })
                const response = await this.setCROAssetNumberForQuestion({
                    questionId: this.question_id,
                    assetNumber: assetNumber,
                })
                console.log(response.result)
                this.setMessageModel({
                    msg: 'Saved',
                    duration: 3000
                })
                this.disablePlacementFieldsTmp = true
                this.questionInfo.cro_asset_number = this.croAssetNumber
            } catch (e) {
                console.log(`error applyAssetNumber:`, e)
                this.setMessageModel({
                    msg: `Asset number \"${assetNumber}\" was not found. Please, enter a correct Asset number and try again.`,
                    duration: 3000
                })
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'apply asset'
                })
            }
        },

        async onAssetTypeItemClick(item) {
            console.log('onAssetTypeItemClick')
            await this.applyAssetType(item)
        },

        async applyAssetType(item) {
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'apply asset type'
                })
                const response = await this.setCROAssetTypeForQuestion({
                    questionId: this.question_id,
                    assetTypeId: item.id,
                    assetTypeName: item.name,
                })
                console.log(response.result)
                this.setMessageModel({
                    msg: 'Saved',
                    duration: 3000
                })
                this.disablePlacementFieldsTmp = true
                this.questionInfo.cro_asset_type = item
                this.croAssetTypeName = item.name
            } catch (error) {
                console.log(`error applyAssetType:`, error)
                if(error.data.error.code == 1219) {
                    this.setMessageModel({
                        msg: `Please set asset number first`,
                        duration: 3000
                    })
                } else {
                    this.setMessageModel({
                        msg: `Some error`,
                        duration: 3000
                    })
                }
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'apply asset type'
                })
            }
        },

        async onSetGeolocationClick() {
            await this.initFetchLocationFlow()
        },
        async initFetchLocationFlow(hidden = false) {
            this.showMapLoader = !hidden
            try {
                let position = await this.fetchUserLocation(30000)
                let obj = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                    accuracy: position.coords.accuracy,
                    date: position.timestamp,
                    source: 'gps'
                }
                console.log('got GPS: ' + position.coords.latitude)
                let res = await this.saveGPS(position.coords.latitude, position.coords.longitude, position.coords.accuracy, position.timestamp)
                if(res) {
                    this.setMessageModel({
                        msg: 'GPS updated',
                        duration: 1000,
                    })
                    this.locationData = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                        accuracy: position.coords.accuracy,
                    }
                    this.questionInfo.location = {
                        point: {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                            accuracy: position.coords.accuracy,
                        },
                        w3w: ''
                    }
                } else {
                    //todo show error?
                }
                let allowedDiffSeconds = 30
                let time = (new Date()).getTime()
                if((time - position.timestamp > allowedDiffSeconds*1000) || position.coords.accuracy > 50) {
                    position = await this.fetchUserLocation(60000)
                    time = (new Date()).getTime()
                    if((time - position.timestamp > allowedDiffSeconds*1000) || position.coords.accuracy > 50) {
                        position = await this.fetchUserLocation(60000)
                    }
                    res = await this.saveGPS(position.coords.latitude, position.coords.longitude, position.coords.accuracy, position.timestamp, true)
                }
            } catch (e) {
                console.log(`kek error:`, e)
                if(e.code == e.PERMISSION_DENIED) {
                    this.allowGpsRequestPopupSettings = {
                        show: true,
                        onOkHandler: () => {
                            console.log('permission');
                            // this.initFetchLocationFlow(hidden)
                        },
                    }
                } else {
                    this.gpsErrorPopupSettings = {
                        show: true,
                        subtitle: e.code == e.TIMEOUT ? this.translate('manageGPSUnableToFetchMsg') : this.translate('manageGPSUnavailable'),
                    }
                }
            } finally {
                this.showMapLoader = false
            }


        },
        showW3Wpopup() {
            this.w3wPopupSettings = {
                show: true
            }
        },
        onMapBlockClick() {
           this.navigateToGoogle()
        },
        navigateToGoogle() {
            let lat = this.locationData.lat
            let lng = this.locationData.lng
            let url = `https://www.google.com/maps/place/${lat},${lng}/@${lat},${lng},17z`
            window.open(url, '_blank')
        },
        moreInfoButtonClick() {
            this.showManualCordsForm = !this.showManualCordsForm
            if (this.showManualCordsForm) {
                localStorage.setItem('qmng_geoinfo_opened', true);
            } else {
                localStorage.setItem('qmng_geoinfo_opened', false);
            }

        },
        onLatClick() {
            this.copyInputToClipboard('latInput', {})
        },
        onLngClick() {
            this.copyInputToClipboard('lngInput', {})
        },
        onW3WInputClick() {
            this.copyInputToClipboard('w3wInput', {})
        },
        copyInputToClipboard(itemId, messageData = null) {
            let item = document.getElementById(itemId);
            let oldType = item.type
            let hidden = oldType == 'hidden'
            if(hidden) item.type = 'text'
            item.select();
            item.setSelectionRange(0, 99999);
            document.execCommand("copy");
            item.setSelectionRange(0, 0);
            if(hidden) item.type = 'hidden'
            if(messageData != null) {
                this.setMessageModel({
                    msg: messageData.msg || this.translate('manageCopiedToClipboard'),
                    duration: messageData.duration || 700
                })
            }
        },

        resetToInitialData() {
            this.assetId = this.questionInfo.asset_id
            this.placement = this.questionInfo.placement
            if (this.questionInfo.location) {
                this.locationData = {
                    lat: this.questionInfo.location.point.lat,
                    lng: this.questionInfo.location.point.lng,
                    source: '',
                    w3w: this.questionInfo.location.w3w,
                }
            } else {
                this.locationData = null
            }
        },

        async onBackToYardClick() {
            try {
                this.setProgressBarTag({
                    show: true,
                    tag: 'back to yard'
                })
                const response = await this.clearPlacementInfo({
                    questionId: this.question_id
                })
                console.log(response.result)
                this.setMessageModel({
                    msg: 'Done',
                    duration: 2000
                })
                this.croJobId = ''
                await this.getQuestionPlaceInfo()
                this.resetToInitialData()
            } catch (e) {
                this.showErrorModal(e.data.error.message)
            } finally {
                this.setProgressBarTag({
                    show: false,
                    tag: 'back to yard'
                })
            }
        },

        async saveGPS(lat, lng, accuracy, originalDate, rewrite = false) {
            let body = {}
            body.lat = lat
            body.lng = lng
            body.accuracy = accuracy
            body.original_date = (new Date(originalDate)).toISOString()
            body.rewrite = rewrite
            console.log(body)
            try {
                let response = await this.saveQuestionGPS({body, questionUid:this.question_id})
                return true
            } catch (e) {
                console.log(`error saveQuestionGPS`, e)
                return false
            }
        },
        onNotEnoughPermissionOkClick() {
            logAnalyticsEvent('qm_no_perm_ok_click')
            location.replace(`${location.origin}/driver`)
        },

        onNotEnoughPermissionLogoutClick() {
            logAnalyticsEvent('qm_no_perm_logout_click')
            this.logout()
        },

        async logout() {
            try {
                await this.logoutRemote()
            } catch (error) {
                console.log('error', error)
            } finally {
                this.removeKeys()
                this.navigateToVoteLogin(this.question_id, this.$route.query.rate_uid, this.$route.query.rate_value)
            }
        },


    }
}
</script>
<style>
.mapProgress svg {
    stroke: white;
    width: 40px !important;
    height: 40px !important;
}
</style>

<style scoped>

.assets_autocomplete_list {
    position: absolute;
    background: #f1f1f1;
    display: flex;
    flex-direction: column;
    left: 23px;
    top: 33px;
    min-width: 200px;
    max-width: 250px;
    max-height: 150px;
    z-index: 5;
    overflow: scroll;
}
.assets_autocomplete_list .item {
    padding: 8px;
    cursor: pointer;
}

.mapProgress {
    width: 40px;
    height: 40px;
}

.place_img {
    width: 64px;
    height: 64px;
    margin: 24px auto 24px;
    box-sizing: border-box;
    border-radius: 50%;
    filter: drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.293679));
}

.place_img img {
    min-width: 64px;
    min-height: 64px;
    margin: 0 auto;
    border-radius: 50%;
    display: block;
    width: 100%;
    height: 100%;
}

.question {
    text-align: center;
    font-size: 1.2em;
    font-weight: 700;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 5px;
}

.question__id {
    text-align: center;
    font-size: 1.2em;
    font-weight: 700;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 26px;
}

.question-map__form {
    margin-top: 30px;
}

.input-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 32px;
    position: relative;
    vertical-align: top;
    padding-right: 23px;
    padding-left: 23px;
}

.asset_type_selector {
    padding-top: 8px;
}

.asset_type_selector .form-lable {
    top: -17px;
}

.map-block__loader {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    padding: 12px;
    color: white;
}

.map-block__loader.default {
    margin-top: 20px;
    background-color: rgba(0, 0, 0, 0.85);
}

.map-block__loader span {
    margin-top: 5px;
}

.map-block__accuracy {
    position: absolute;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    width: 100%;
    text-align: center;
    padding: 2px;
    color: white;
    font-style: normal;
    font-weight: normal;
    mix-blend-mode: normal;
    font-size: 14px;
    opacity: 0.7;
}

.input-cords__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    vertical-align: top;
    padding-right: 15px;
    padding-left: 23px;
}

.input-cords__wrapper-second {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    vertical-align: top;
    padding-right: 23px;
    padding-left: 15px;
}

.map-picture {
    height: 155px;
    width: 100%;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.map-image__overlay img {
    width: 100%
}

.form-lable {
    position: absolute;
    pointer-events: none;
    left: 23px;
    top: -15px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    transition: .3s;
    opacity: 0.7;
    color: #2F2F2F;
}

.field_action_btn {
    margin-left: 8px;
    background: #3F405C;
    border-radius: 6px;
    color: #ffffff;
    border: 0;
    cursor: pointer;
    height: 38px;
    display: flex;
    align-items: center;
    align-content: center;
    padding-left: 8px;
    padding-right: 8px;
    min-width: 80px;
    justify-content: center
}

.field_action_btn.disabled {
    background: #b6b6b6;
    cursor: default;
}

.cords-form__label-lat {
    position: absolute;
    pointer-events: none;
    left: 23px;
    top: -15px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    transition: .3s;
    opacity: 0.7;
    color: #2F2F2F;
}

.cords-form__label-lng {
    position: absolute;
    pointer-events: none;
    left: 15px;
    top: -15px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    transition: .3s;
    opacity: 0.7;
    color: #2F2F2F;
}

input {
    outline: none;
    color: #2F2F2F;
    border-bottom: 2px solid #3F405C;
    background-color: white;
    width: 100%;
    padding-bottom: 5px;
    border-radius: 0;
    padding-left: 0;
}

.map-image {
    display: flex;
    justify-content: center;
    position: relative;
}

.map-image .overlay-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .6);
    display: flex;
    align-items: center;
    justify-content: center;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 28px;
    color: white;

}

.map-image__overlay {
    position: relative;
    width: 100%;
    position: relative;
    margin-left: 23px;
    margin-right: 23px;
    cursor: pointer;
}

.back_to_yard-btn-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 40px;
}

.back_to_yard-btn {
    margin-left: 23px;
    margin-right: 23px;
    margin-top: 23px;
    background: #3F405C;
    border-radius: 6px;
    color: #ffffff;
    border: 0;
    padding: 12px 62px;
    cursor: pointer;
}

.save-btn {
    background: #3F405C;
    border-radius: 6px;
    color: #ffffff;
    border: 0;
    padding: 12px 62px;
    cursor: pointer;
}

.reset-btn {
    color: #3F405C;
    font-family: Nunito;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    cursor: pointer;
}

.click-input {
    cursor: pointer;
}

.block-title {
    margin-left: 25px;
    margin-bottom: 13px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #2F2F2F;
    opacity: 0.7;
}

.modal-map {
    margin-left: 25px;
    margin-right: 13px;
    width: 100%;
}

.map-picture {
    position: relative;
}

.modal-map img {
    position: relative;
}

.map-point {
    width: 32px;
    position: absolute;
    transform: translate(0%, -50%);
}

.map-block__content {
    display: flex;
}

.update-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 2px solid #3F405C;
    box-sizing: border-box;
    border-radius: 6px;
    padding: 23px 13px;
    margin-right: 25px;
    cursor: pointer;
}

.update-btn__text {
    margin-top: 14px;
}

.update-btn__text_sub {
    font-size: 12px;
}

.cords-btn {
    display: flex;
    justify-content: center;
    border: 2px solid #3F405C;
    box-sizing: border-box;
    border-radius: 6px;
    margin-right: 25px;
    margin-top: 5px;
    padding: 6px;
    margin-top: 10px;
    cursor: pointer;
}

.cords-btn__icon {
    margin-right: 11px;
}

.cords-form {
    margin-top: 40px;
}

.cords-input__number {
    display: flex;
}

.cords-input__w3w {
    position: relative;
    margin-top: 25px;
}

.w3w-icon {
    position: absolute;
    right: 25px;
    top: 0;
    cursor: pointer;

}

.face-rate {
    max-width: 425px;
    margin: auto;
    width: 100%;
}


</style>
